import { defaultInitialState, loadingState, updatedState, getErrorState } from '../utils';
import { SET_PHONE, SET_PHONE_DONE, SET_PHONE_ERROR, SET_PHONE_RESET, VERIFY_PHONE, VERIFY_PHONE_DONE, VERIFY_PHONE_ERROR } from './actionTypes';
const initialState = Object.assign(Object.assign({}, defaultInitialState), { data: { requestVerification: false } });
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_PHONE:
            return Object.assign(Object.assign({}, state), loadingState);
        case SET_PHONE_DONE:
            return Object.assign(Object.assign(Object.assign({}, state), updatedState), { data: Object.assign(Object.assign({}, action.data), { requestVerification: true }) });
        case SET_PHONE_ERROR:
            return Object.assign(Object.assign({}, state), getErrorState(action.errorMessage));
        case VERIFY_PHONE:
            return Object.assign(Object.assign({}, state), loadingState);
        case VERIFY_PHONE_DONE:
            return Object.assign(Object.assign(Object.assign({}, state), updatedState), { data: Object.assign(Object.assign({}, state.data), { requestVerification: false }) });
        case VERIFY_PHONE_ERROR:
            return Object.assign(Object.assign({}, state), getErrorState(action.errorMessage === 'invalid_pin' ? 'wrong_pin' : action.errorMessage) // invalid_pin is reserved for credit card errors so in this case we need to overide it to wrong_pin to show correct message
            );
        case SET_PHONE_RESET:
            return initialState;
        default:
            return state;
    }
};
export default reducer;
//# sourceMappingURL=reducer.js.map